import React, { useCallback } from 'react';
import i18n from '../../../../../i18n';

import { makeStyles } from '@material-ui/core/styles';
import { Text, TextTypography } from 'components/Text/Text';
import { SmallButton } from 'components/SmallButton/SmallButton';
import { useAction } from 'core/store/store';
import { makeSnackbarCreateAction } from 'state/snackbar/actions';
import { SnackbarMessageType } from 'state/snackbar/reducer';
import { getClientUrl, makeUrl } from 'core/utils/utils';
import { RoutePath } from 'RoutePath';
import { PublishButton } from 'components/PublishButton/PublishButton';
import { useSelector } from 'react-redux';
import { authIsoCodeSelector } from 'state/auth/selectors';

export interface LinkWidgetParams {
    storeLink: string;
}

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',
        height: '100%',
        [theme.breakpoints.up('sm')]: {
            height: 256,
        },
        background: 'rgba(15, 24, 37, 0.05)',
        borderRadius: 20,
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
    },
    text: {
        marginTop: theme.spacing(2),
    },
    link: {
        marginTop: theme.spacing(2),
        cursor: 'pointer',
    },
    button: {
        marginTop: theme.spacing(1.5),
    },
}));

export const LinkWidget = (params: LinkWidgetParams) => {
    const storeIsoCode = useSelector(authIsoCodeSelector);
    const action = useAction();
    const classes = useStyles();
    const { t } = i18n.useTranslation();

    const clientUrlHost = new URL(getClientUrl(storeIsoCode)).host;
    const fullLink = `${clientUrlHost}/${params.storeLink}`;

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText('https://' + fullLink).then(
            function () {
                action(makeSnackbarCreateAction, SnackbarMessageType.SUCCESS_COPY, {});
            },
            function (err) {
                console.error('Async: Could not copy text: ', err);
            },
        );
    }, [action, fullLink]);

    const goToStore = () => {
        const url = `https://${clientUrlHost}${makeUrl(RoutePath.STORE, { storeSlug: params.storeLink })}`
        window.open(url, '_blank')
    }

    return (
        <div className={classes.container}>
            <Text typography={TextTypography.LEAD_ACCENT}>{t('vendor:dashboard:linkWidget:title')}</Text>
            <Text className={classes.text} typography={TextTypography.BODY}>
                {t('vendor:dashboard:linkWidget:info')}
            </Text>
            <div
                className={classes.link}
                onClick={goToStore}
            >
                <Text typography={TextTypography.BODY_ACCENT}>{fullLink}</Text>
            </div>
            <div className={classes.button}>
                <PublishButton />
            </div>
            <div className={classes.button}>
                <SmallButton text={'vendor:dashboard:linkWidget:copy'} width={210} onClick={handleCopy} />
            </div>
        </div>
    );
};
